// Generated by GitHub Copilot
import { Api } from "../Api";
import Account from "#core/entities/auth/accounts/Account.ts";

/** API for the authenticated user's own account credentials. Requires a valid access token. */
export default class AccountApi extends Api<AccountApi> {
    /**
     * Changes the current user's password. The backend verifies `currentPassword`
     * against the stored hash before applying `newPassword`; a wrong current password
     * surfaces as a 400 {@link ApiError}, an accountless (SSO-only) user as a 404.
     */
    public async changePassword(currentPassword: string, newPassword: string): Promise<void> {
        await this.patch<{ changed: boolean }>("auth/account/me/password", {
            current_password: currentPassword,
            new_password: newPassword,
        });
    }

    /** Every account the signed-in user can sign in with. */
    public async listAccounts(): Promise<Account[]> {
        return (await this.get<Account[]>("auth/account/me/accounts", undefined, Account)) ?? [];
    }

    /** Removes one of the signed-in user's accounts; 409 for the last one, 404 when it is not theirs. */
    public async removeAccount(id: string): Promise<void> {
        await this.delete(`auth/account/me/accounts/${id}`);
    }
}
